import { states } from "@covertree/consts";
import {
  AdditionalInterestInput,
  AdditionalInterestType,
} from "@covertree/new-business-graphql";

export interface AdditionalInterestFormData {
  name: string;
  type: AdditionalInterestType;
  streetAddress: string;
  lotUnit?: string | null;
  city: string;
  state: {
    label: string;
    value: string;
  };
  zipCode: string;
  email?: string | null;
  accountNumber?: string | null;
  isBilling: boolean;
}

export const defaultFormData: AdditionalInterestFormData = {
  name: "",
  type: null as unknown as AdditionalInterestType,
  streetAddress: "",
  lotUnit: undefined,
  city: "",
  state: {
    label: "",
    value: "",
  },
  zipCode: "",
  email: undefined,
  accountNumber: undefined,
  isBilling: false,
};

/**
 * Maps an array of additional interest data from GraphQL format to the form data format
 * @param additionalInterest - Array of AdditionalInterestInput from GraphQL schema, or null/undefined
 * @returns Array of AdditionalInterestFormData, or undefined if input is null/undefined
 */
export const mapAdditionalInterestToFormData = (
  additionalInterest?: Omit<AdditionalInterestInput, "isBilling">[] | null
): AdditionalInterestFormData[] | undefined => {
  if (!additionalInterest) return undefined;
  return additionalInterest.map((interest) => ({
    ...interest,
    type: interest.type as AdditionalInterestType,
    lotUnit: interest.lotUnit ?? null,
    email: interest.email ?? null,
    accountNumber: interest.accountNumber ?? null,
    state: {
      label: states.find((state) => state.value === interest.state)!.label,
      value: interest.state,
    },
    isBilling: false,
  }));
};

/**
 * Maps an array of additional interest form data to the GraphQL mutation input format
 * @param additionalInterest - Array of AdditionalInterestFormData
 * @returns Array of AdditionalInterestInput for GraphQL mutation
 */
export const mapAdditionalInterestToPayload = (
  additionalInterest: AdditionalInterestFormData[]
): AdditionalInterestInput[] => {
  return additionalInterest.map((interest) => ({
    ...interest,
    accountNumber: interest.accountNumber || null,
    email: interest.email || null,
    lotUnit: interest.lotUnit || null,
    state: interest.state.value,
  }));
};
